import type { KyInstance } from "ky";

import { type PacingMetricsResponse } from "./getPacingMetrics";
import { getTodayTimeframe } from "./getTodayTimeframe";

export const getTodayPacingMetrics = async (client: KyInstance): Promise<PacingMetricsResponse> => {
    const { start, end } = getTodayTimeframe();

    return await client
        .get("v1/metrics/pacing", { retry: 0, searchParams: { start, end } })
        .json<PacingMetricsResponse>();
};
